import { render, staticRenderFns } from "./BuscadorCobroPage.vue?vue&type=template&id=3680e22e"
import script from "./BuscadorCobroPage.js?vue&type=script&lang=js&external"
export * from "./BuscadorCobroPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports